//const baseUrl = "http://localhost:8000";
const baseUrl = "https://dev-api.trustspike.io";
const authurl = baseUrl + "/v1/client/auth";
const plaformURL = baseUrl + "/v1/platform";
const userurl = baseUrl + "/v1/client";
const vendorUrl = baseUrl + "/v1/email";
export const userurl1 = baseUrl + "/v1/";
const signal = new AbortController().signal;

export function login(data, token) {
  return fetch(authurl + "/login", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function checkAuthType(email, token) {
  return fetch(authurl + "/preLoginCheck", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: token,
    },
    body: JSON.stringify(email),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function forgetLogin(data, token) {
  return fetch(authurl + "/forgetLogin", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function resetPassword(token, email) {
  const data = { email: email };
  return fetch(userurl1 + "client/auth/forgotpassword", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function logout(token, email) {
  return fetch(authurl + "/logout", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({ refreshToken: token, email }),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}
export function platformLogout(token, email) {
  return fetch(plaformURL + "/auth/logout", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({ refreshToken: token, email }),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getRbacAccess(token, userScope) {
  return fetch(userurl1 + "template/getTemplateByRole?role=" + userScope, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}
export function getIntegrationDataWithScanStatus(
  token,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  status = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl1}client/integration/with-scan-status?sortBy=${sortBy}&limit=${limit}&page=${page}`;
  if (name !== "") apiUrl += `&name=${name}`;
  if (status !== "") apiUrl += `&status=${status}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}
export function getIntegrationData(
  token,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  status = "",
  cloud = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl1}client/integration?sortBy=${sortBy}&limit=${limit}&page=${page}`;
  if (name !== "") apiUrl += `&searchBy=${name}`;
  if (status !== "") apiUrl += `&status=${status}`;
  if (cloud !== "") apiUrl += `&cloud=${cloud}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getInventoryAwsData(
  token,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  type = "",
  accountId = "",
  service
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl}/getAWSCiem?sortBy=${sortBy}&limit=${limit}&page=${page}`;
  if (name !== "") apiUrl += `&searchBy=${name}`;
  if (type !== "") apiUrl += `&type=${type}`;
  if (accountId !== "") apiUrl += `&accountId=${accountId}`;
  if (service !== "") apiUrl += `&service=${service}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}
export function getInventoryAwsApplicationData(
  token,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  type = "",
  accountId = "",
  application
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl}/getAWSCiem?sortBy=${sortBy}&limit=${limit}&page=${page}`;
  if (name !== "") apiUrl += `&searchBy=${name}`;
  if (type !== "") apiUrl += `&type=${type}`;
  if (accountId !== "") apiUrl += `&accountId=${accountId}`;
  if (application !== "") apiUrl += `&service=${application}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getUserData(
  token,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  status = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl}/users?sortBy=${sortBy}&limit=${limit}&page=${page}`;
  if (name !== "") apiUrl += `&searchBy=${name}`;
  if (status !== "") apiUrl += `&status=${status}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}
export function getPlatformUserData(
  token,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  status = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${plaformURL}/user?sortBy=${sortBy}&limit=${limit}&page=${page}`;
  if (name !== "") apiUrl += `&searchBy=${name}`;
  if (status !== "") apiUrl += `&status=${status}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}
export function getScanReportHubData(
  token,
  scanId,
  currentPage,
  limit,
  searchBy
) {
  let apiUrl = `${userurl1}scan/scanResult?scanId=${scanId}&collection=scanresultdata&page=${currentPage}&limit=${limit}`;
  if (searchBy !== "") apiUrl += `&keyword=${searchBy}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function fetchScanData(url, token) {
  return fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getScanReportData(token, data) {
  let apiUrl = `${userurl1}scan/scanReport?cloudAccountId=${data.cloudAccountId}&=&project_name=${data.project_name}&subscription_id=${data.subscription_id}&cloud=${data.name}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}
export function getScanPolicyData(
  token,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  cloud = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl1}collection/plugindata?sortBy=${sortBy}&limit=${limit}&page=${page}`;
  if (name !== "") apiUrl += `&searchBy=${name}`;
  if (cloud !== "") apiUrl += `&cloud=${cloud}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

// Evidence
export function getStandardData(
  token,
  endpoint,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  status = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl1}collection/${endpoint}?sortBy=${sortBy}&limit=${limit}&page=${page}`;
  if (name !== "") apiUrl += `&name=${name}`;
  if (status !== "") apiUrl += `&status=${status}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getEvidenceCollectionData(
  token,
  collection,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl1}collection/${collection}?sortBy=${sortBy}&limit=${limit}&page=${page}`;
  if (name !== "") apiUrl += `&name=${name}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getAuditData(
  token,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  status = "",
  standard = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl}/audit?sortBy=${sortBy}&limit=${limit}&page=${page}`;
  if (name !== "") apiUrl += `&searchBy=${name}`;
  if (standard !== "") apiUrl += `&standard=${standard}`;
  if (status !== "") apiUrl += `&status=${status}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getDepartmentOption(token) {
  let apiUrl = `${userurl}/department`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getPcidssv321Data(
  token,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  status = "",
  standard = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl1}collection/pcidssv321data?$page=${page}&limit=${limit}&keyword="`;
  if (name !== "") apiUrl += `&name=${name}`;
  if (standard !== "") apiUrl += `&standard=${standard}`;
  if (status !== "") apiUrl += `&status=${status}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getPcidssv4Data(
  token,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  status = "",
  standard = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl1}collection/pcidssv4data?$page=${page}&limit=${limit}&keyword="`;
  if (name !== "") apiUrl += `&name=${name}`;
  if (standard !== "") apiUrl += `&standard=${standard}`;
  if (status !== "") apiUrl += `&status=${status}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function createAuditData(token, data) {
  let apiUrl = `${userurl}/audit`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function createVendorThroughExcelUpload(token, data) {
  let apiUrl = `${userurl}/vendor/createVendor/Excel/upload`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function createPeopleThroughExcelUpload(token, data) {
  let apiUrl = `${userurl}/people/upload-excel`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function uploadFiles(token, files) {
  let apiUrl = `${userurl}/uploads/upload-multiple`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
    },
    body: files,
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function VendorSendPageUploadFiles(token, files) {
  let apiUrl = `${vendorUrl}/vendorRole/upload-multiple`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
    },
    body: files,
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function createException(token, data) {
  let apiUrl = `${userurl1}collection/client/exception`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}
export function createPolicyData(token, data) {
  let apiUrl = `${userurl}/policy`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
    },
    body: data,
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function editAuditData(token, data, id) {
  let apiUrl = `${userurl1}collection/auditdata/${id}`;
  return fetch(apiUrl, {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function editPeopleData(token, data, id) {
  let apiUrl = `${userurl}/people/${id}`;
  return fetch(apiUrl, {
    method: "PATCH",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function documentVerification(token, id) {
  let apiUrl = `${userurl}/policy/upload/${id}`;
  return fetch(apiUrl, {
    method: "PATCH",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getClientURL(token, fileName) {
  let apiUrl = `${userurl1}client/file-url?fileName=${fileName}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function editPolicyData(token, data, id) {
  let apiUrl = `${userurl}/policy/${id}`;
  return fetch(apiUrl, {
    method: "PATCH",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function deletePolicy(token, id) {
  const apiUrl = `${userurl}/policy/${id}`;
  return fetch(apiUrl, {
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function deletePeople(token, id) {
  const apiUrl = `${userurl}/people/${id}`;
  return fetch(apiUrl, {
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function deleteVendorAPI(token, id) {
  const apiUrl = `${userurl}/vendor/${id}`;
  return fetch(apiUrl, {
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function deleteQuestionnaireAPI(token, id) {
  const apiUrl = `${userurl}/questionnaire/${id}`;
  return fetch(apiUrl, {
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function deleteClientUser(token, id) {
  const apiUrl = `${userurl}/users/${id}`;
  return fetch(apiUrl, {
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getServiceRequestData(
  token,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  status = "",
  type = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl}/service-request?sortBy=${sortBy}&limit=${limit}&page=${page}`;
  if (name !== "") apiUrl += `&searchBy=${name}`;
  if (status !== "") apiUrl += `&status=${status}`;
  if (type !== "") apiUrl += `&type=${type}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getVendorPage(token) {
  let apiUrl = `${vendorUrl}/vendorRole/token/response`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function submitResponseByVendor(token, data) {
  let apiUrl = `${vendorUrl}/vendorRole/token/response`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getReassignedQuestionDataVendorPage(
  token,
  vendorId,
  quesId,
  vendorQuestionnaireId,
  limit = 10,
  page = 1,
  status = ""
) {
  let apiUrl = `${vendorUrl}/vendorRole/reassign/response?page=${page}&limit=${limit}`;
  if (vendorId !== "") apiUrl += `&vendorId=${vendorId}`;
  if (quesId !== "") apiUrl += `&questionnaireId=${quesId}`;
  if (vendorQuestionnaireId !== "")
    apiUrl += `&vendorQuestionnaireId=${vendorQuestionnaireId}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getSinglePeople(token, peopleId) {
  let apiUrl = `${userurl}/people/${peopleId}`;

  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function createTrainingData(token, data) {
  let apiUrl = `${userurl}/training`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
    },
    body: data,
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function assignTrainingInPeople(token, data) {
  let apiUrl = `${userurl}/people/assign-training`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function verifyPeopleTraining(token, data) {
  let apiUrl = `${userurl}/people/verify-training`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function sendEmailToVendor(token, vendorId) {
  let apiUrl = `${userurl}/vendor/send/mail/${vendorId}`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function createServiceRequestData(token, data) {
  let apiUrl = `${userurl}/service-request/newRequest`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function createUserManagementData(token, data) {
  let apiUrl = `${userurl}/users`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function editUserData(token, data, id) {
  let apiUrl = `${userurl}/users/${id}`;
  return fetch(apiUrl, {
    method: "PATCH",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function editVendorData(token, data, id) {
  let apiUrl = `${userurl}/vendor/${id}`;
  return fetch(apiUrl, {
    method: "PATCH",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function assignQuestionnaireToVendor(token, data, id) {
  let apiUrl = `${userurl}/questionnaire/${id}`;
  return fetch(apiUrl, {
    method: "PATCH",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function createVendorData(token, data) {
  let apiUrl = `${userurl}/vendor`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function submitQuestionResponse(token, data) {
  let apiUrl = `${userurl}/questionResponse`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getAllVendorsByReviewer(
  token,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  status = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl}/vendor/reviewer?limit=${limit}&page=${page}&sortBy=${sortBy}`;
  if (name !== "") apiUrl += `&searchBy=${name}`;
  if (status !== "") apiUrl += `&status=${status}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getAllVendorsResponse(
  token,
  userId,
  vendorId,
  questionnaireId,
  limit = 10,
  page = 1,
  status = "",
  vendorQuestionnaireId
) {
  let apiUrl = `${userurl}/questionResponse/reviewer?page=${page}&limit=${limit}`;
  if (userId !== "") apiUrl += `&userId=${userId}`;
  if (vendorId !== "") apiUrl += `&vendorId=${vendorId}`;
  if (questionnaireId !== "") apiUrl += `&questionnaireId=${questionnaireId}`;
  if (vendorQuestionnaireId !== "")
    apiUrl += `&vendorQuestionnaireId=${vendorQuestionnaireId}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getReassignedQuestionData(
  token,
  id,
  quesId,
  vendorQuestionnaireId,
  limit = 200,
  page = 1,
  status = ""
) {
  let apiUrl = `${userurl}/questionResponse?page=${page}&limit=${limit}`;
  if (id !== "") apiUrl += `&vendorId=${id}`;
  if (quesId !== "") apiUrl += `&questionnaireId=${quesId}`;
  if (vendorQuestionnaireId !== "")
    apiUrl += `&vendorQuestionnaireId=${vendorQuestionnaireId}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function createQuestionnaireData(token, data) {
  let apiUrl = `${userurl}/questionnaire`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
    },
    body: data,
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function createPeopleData(token, data) {
  let apiUrl = `${userurl}/people`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getNotificationData(token) {
  let apiUrl = `${userurl1}collection/notification?page=&limit=`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function deleteNotification(token, notificationId) {
  const apiUrl = `${userurl1}collection/notification/${notificationId}`;
  return fetch(apiUrl, {
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getPeopleData(
  token,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  employeeStatus = "",
  employeeCompliantStatus = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl}/people?sortBy=${sortBy}&limit=${limit}&page=${page}`;
  if (name !== "") apiUrl += `&searchBy=${name}`;
  if (employeeStatus !== "") apiUrl += `&employeeStatus=${employeeStatus}`;
  if (employeeCompliantStatus !== "")
    apiUrl += `&employeeCompliantStatus=${employeeCompliantStatus}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getVendorData(
  token,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  status = "",
  compliantStatus = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl}/vendor?sortBy=${sortBy}&limit=${limit}&page=${page}`;
  if (name !== "") apiUrl += `&searchBy=${name}`;
  if (compliantStatus !== "") apiUrl += `&compliantStatus=${compliantStatus}`;
  if (status !== "") apiUrl += `&status=${status}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getSingleVendorData(token, id) {
  let apiUrl = `${userurl}/vendor/${id}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getPolicyManagementData(
  token,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  status = "",
  compliantStatus = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl}/policy?sortBy=${sortBy}&limit=${limit}&page=${page}`;
  if (name !== "") apiUrl += `&name=${name}`;
  if (compliantStatus !== "") apiUrl += `&compliantStatus=${compliantStatus}`;
  if (status !== "") apiUrl += `&status=${status}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}
export function getQuestionnaireData(
  token,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  status = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl}/questionnaire?sortBy=${sortBy}&limit=${limit}&page=${page}`;
  if (name !== "") apiUrl += `&name=${name}`;
  if (status !== "") apiUrl += `&status=${status}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getSingleQuestionnaireData(token, id) {
  let apiUrl = `${userurl}/questionnaire/${id}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getPieChartData(token, type) {
  let apiUrl = `${userurl1}collection/client/pieChart/${type}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getEvidenceTaskData(
  token,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  status = "",
  auditId = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl}/evidence?sortBy=${sortBy}&limit=${limit}&page=${page}`;
  if (name !== "") apiUrl += `&name=${name}`;
  if (auditId !== "") apiUrl += `&auditId=${auditId}`;
  if (status !== "") apiUrl += `&status=${status}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}
export function getScanData(
  token,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  compliantStatus = "",
  cloudAccountId = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl}/scan?sortBy=${sortBy}&limit=${limit}&page=${page}`;
  if (name !== "") apiUrl += `&searchBy=${name}`;
  if (cloudAccountId !== "") apiUrl += `&cloudAccountId=${cloudAccountId}`;
  if (compliantStatus !== "") apiUrl += `&compliantStatus=${compliantStatus}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}
export function getClientRoleData(
  token,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  status = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl}/clientRole?sortBy=${sortBy}&limit=${limit}&page=${page}`;
  if (name !== "") apiUrl += `&searchBy=${name}`;
  if (status !== "") apiUrl += `&status=${status}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getTrainingData(
  token,
  name = "",
  sortBy = "",
  limit = 10,
  page = 1,
  status = "",
  mandatory = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl}/training?sortBy=${sortBy}&limit=${limit}&page=${page}`;
  if (name !== "") apiUrl += `&searchBy=${name}`;
  if (status !== "") apiUrl += `&status=${status}`;
  if (mandatory !== "") apiUrl += `&isMandatory=${mandatory}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getDashboardData(token) {
  return fetch(userurl + "/dashboard/security", {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getCisoDashboardData(token) {
  return fetch(userurl + "/dashboard/ciso", {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function createNewUser(data, token) {
  return fetch(userurl + "/users", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error("Error in creatUser Api:: ", e));
}

export function getUsers(params, token) {
  return fetch(userurl + params, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    signal: signal,
  })
    .then((res) => res.json())
    .catch((e) => {
      console.error(e);
    });
}

// Shubham start
export function getUsers1(params) {
  return fetch(userurl1 + params, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
    signal: signal,
  })
    .then((res) => res.json())
    .catch((e) => {
      console.error(e);
    });
}

export function deleteUser1(params) {
  return fetch(userurl1 + params, {
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      // Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error("Error in deleteUser Api:: ", e));

  // var requestOptions = {
  //   method: "DELETE",
  //   redirect: "follow",
  // };

  // return fetch(userurl1 + params, requestOptions)
  //   .then((response) => response.text())
  //   .then((result) => console.log(result))
  //   .catch((error) => console.log("error", error));
}

export function updateUser(params, data, token) {
  return fetch(userurl1 + params, {
    method: "PATCH",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error("Error in updateUser Api:: ", e));
}

export function deleteUser(params, token) {
  return fetch(userurl + params, {
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error("Error in deleteUser Api:: ", e));
}

export function addRole(data, token) {
  return fetch(userurl + "/createRole", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error("Error in addRole Api:: ", e));
}

export function getallRoles(params, token) {
  return fetch(userurl + params, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json(), console.log("fetch role", userurl, params))
    .catch((e) => console.error("Error in getRoles Api:: ", e));
}
export function getallRoles1(params) {
  return fetch(userurl + params, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error("Error in getRoles Api:: ", e));
}

export function getallIntegration(params, token) {
  return fetch(userurl + params, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error("Error in getallIntegration Api:: ", e));
}

export function createNewIntegration(data, token) {
  return fetch(userurl + "/integration", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error("Error in addIntegration Api:: ", e));
}
export function createRole(data, token) {
  return fetch(userurl1 + "collection/roledata", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error("Error in addIntegration Api:: ", e));
}

export function createClientRole(data, token) {
  return fetch(userurl + "/clientRole", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error("Error in addIntegration Api:: ", e));
}

export function createNewEvidence(data, token) {
  return fetch(userurl + "/evidence", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error("Error in addIntegration Api:: ", e));
}

export function createPerformScan(data, token) {
  return fetch(userurl + "/scan/performScan", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error("Error in addIntegration Api:: ", e));
}

export function updateIntegration(params, data, token) {
  return fetch(userurl + params, {
    method: "PATCH",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error("Error in addIntegration Api:: ", e));
}

export function updateQuestionResponseDataBasedOnReviewer(token, data) {
  let apiUrl = `${userurl}/questionResponse/reviewer`;
  return fetch(apiUrl, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data), // Pass data directly
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function updateRole(params, data, token) {
  return fetch(userurl + "/clientRole" + params, {
    method: "PATCH",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error("Error in updateRole Api:: ", e));
}
export function updateInventoryAssets(id, data, token) {
  return fetch(userurl1 + "collection/integrationdata/" + id, {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => console.error("Error in updateRole Api:: ", e));
}

export function getallnonComplianceData(
  token,
  sortBy = "",
  limit = "",
  page = "",
  type = ""
) {
  return fetch(
    userurl1 +
      `client/exception/non-compliance?type=${type}&limit=${limit}&page=${page}&sortBy=${sortBy}`,
    {
      headers: {
        "Content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: "Bearer " + token,
      },
      method: "GET",
    }
  )
    .then((d) => d.json())
    .catch((e) => e);
}

export function getExpectionData(
  token,
  name = "",
  page = 1,
  limit = 10,
  sortBy = "",
  status = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${userurl1}collection/client/get/exception?page=${page}&limit=${limit}&sortBy=${sortBy}`;
  if (name !== "") apiUrl += `&searchBy=${name}`;
  if (status !== "") apiUrl += `&status=${status}`;
  return fetch(apiUrl, {
    headers: {
      "Content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    method: "GET",
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function deleteExpectionAPI(token, id) {
  const apiUrl = `${userurl1}collection/client/exception/${id}`;
  return fetch(apiUrl, {
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function createExpection(body, token) {
  const apiUrl = `${userurl1}collection/client/exception`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

//platform
export function getAllClientsData(
  token,
  page = 1,
  limit = 10,
  sortBy = "",
  searchBy = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${plaformURL}/client?page=${page}&limit=${limit}&sortBy=${sortBy}`;
  if (searchBy !== "") apiUrl += `&searchBy=${searchBy}`;
  return fetch(apiUrl, {
    headers: {
      "Content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    method: "GET",
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function getClientsDataByClientId(
  token,
  page = 1,
  limit = 10,
  sortBy = "",
  searchBy = "",
  clientId
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${plaformURL}/client/${clientId}?page=${page}&limit=${limit}&sortBy=${sortBy}`;
  if (searchBy !== "") apiUrl += `&searchBy=${searchBy}`;
  return fetch(apiUrl, {
    headers: {
      "Content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    method: "GET",
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function updatePlatformClient(token, body, clientId) {
  const apiUrl = `${plaformURL}/client/${clientId}`;
  return fetch(apiUrl, {
    method: "PATCH",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function createPlatformClient(body, token) {
  const apiUrl = `${plaformURL}/client`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getPlatformRoleData(
  token,
  page = 1,
  limit = 10,
  sortBy = "",
  searchBy = "",
  status = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${plaformURL}/role?page=${page}&limit=${limit}&sortBy=${sortBy}`;
  if (searchBy !== "") apiUrl += `&searchBy=${searchBy}`;
  if (status !== "") apiUrl += `&status=${status}`;
  return fetch(apiUrl, {
    headers: {
      "Content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    method: "GET",
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function getPlatformProgramData(
  token,
  page = 1,
  limit = 10,
  sortBy = "",
  searchBy = "",
  status = ""
) {
  if (sortBy === "") sortBy = "asc";
  let apiUrl = `${plaformURL}/program?page=${page}&limit=${limit}&sortBy=${sortBy}`;
  if (searchBy !== "") apiUrl += `&searchBy=${searchBy}`;
  if (status !== "") apiUrl += `&status=${status}`;
  return fetch(apiUrl, {
    headers: {
      "Content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    method: "GET",
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function createPlatformProgram(token, body) {
  const apiUrl = `${plaformURL}/program`;
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function updatePlatformProgram(token, body, programId) {
  const apiUrl = `${plaformURL}/program/${programId}`;
  return fetch(apiUrl, {
    method: "PATCH",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}

export function getSingleEvidenceDataForUpdate(token, id) {
  const apiUrl = `${userurl1}client/evidence/${id}`;
  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}
export function updateEvidenceData(body, token, id) {
  const apiUrl = `${userurl1}client/evidence/${id}`;
  return fetch(apiUrl, {
    method: "PATCH",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
}
